import MenuHorizontalIcon from '@assets/icons/menu-horizontal.svg';
import React, { useMemo, useState } from 'react';
import { Button } from '@/components/button';
import {
  DropdownMenu,
  DropdownMenuItemProps,
} from '@usepepper/ui/molecules/dropdown-menu';
import { PaymentsActionListOption } from '@/hooks/payments/use-payments-screen-more-actions';

interface Props {
  actions: PaymentsActionListOption[];
}

export const PaymentsScreenActions: React.FC<Props> = ({ actions }) => {
  const [showActions, setShowActions] = useState(false);

  const dropdownMenuData: DropdownMenuItemProps[] = useMemo(() => {
    return actions.map((action) => {
      const Icon = action.metadata?.Icon;
      return {
        label: action.title,
        leftElement: Icon ? (
          <Icon height={16} width={16} {...action.metadata?.iconProps} />
        ) : undefined,
        onPress: () => {
          action.metadata?.onPress?.();
          setShowActions(false);
        },
      };
    });
  }, [actions]);

  return (
    <DropdownMenu
      isVisible={showActions}
      listData={dropdownMenuData}
      onClose={() => setShowActions(false)}
      position="bottom-end"
      trigger={
        <Button
          Icon={MenuHorizontalIcon}
          onPress={() => setShowActions(true)}
          size="small"
          testID="payments-screen-actions-button"
          trackingData={{ name: 'payments_screen.more_actions' }}
          type="tertiary"
        />
      }
    />
  );
};
